export const ENTER_SUB_TRANSITION_TIME_MS = 180;
export const ENTER_TRANSITION_TIME_MS = 300;
export const EXIT_SUB_TRANSITION_TIME_MS = 150;
export const EXIT_TRANSITION_TIME_MS = 250;
export const TRANSITION_FN = 'cubic-bezier(0.16, 0.84, 0.44, 1)';